import React from 'react'

export default ({
  className = ''
}) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12"><path d="M1.125-10.5A1.126,1.126,0,0,0,0-9.375v1.5A.375.375,0,0,0,.375-7.5H2.25V-9.375A1.126,1.126,0,0,0,1.125-10.5ZM6-.83V-2.25h6.75v-6A2.252,2.252,0,0,0,10.5-10.5H2.615A1.857,1.857,0,0,1,3-9.375V-.75A1.5,1.5,0,0,0,4.752.729,1.556,1.556,0,0,0,6-.83Zm.75-.67v.75A2.253,2.253,0,0,1,4.5,1.5h7.875A2.625,2.625,0,0,0,15-1.125a.375.375,0,0,0-.375-.375Z" transform="translate(0 10.5)" /></svg>
  )